<template>
  <div :class="{
    'text-danger': object.status === 'error',
    'text-muted': ['waiting', 'paused'].includes(object.status),
    'text-success': object.status === 'sent'
  }">
    <WarningSvg v-if="object.status === 'error'" class="mr-2 svg-red"/>
    <ClockSvg v-if="object.status === 'waiting'" class="mr-2"/>
    <PauseSvg v-if="object.status === 'paused'" class="mr-2"/>
    {{ $t(object.status) }}
  </div>
</template>

<script setup>
import WarningSvg from '@/assets/svg-vue/general/warning.svg'
import ClockSvg from '@/assets/svg-vue/header/clock3.svg'
import PauseSvg from '@/assets/svg-vue/marketing/pause.svg'

defineProps({
  object: {
    type: Object
  }
})
</script>
